module.exports = __webpack_public_path__ + "static/media/Python.71374043.svg";